import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  setLoading,
  notificationFail,
  notificationSuccess,
  notificationClear,
  setflowDataLoading,
  setUIFormPayloadLoading,
} from "../slices/notificationSlice";
import {
  setAllFormData,
  setSingleFormData,
  setUserForm,
  setSectionId,
  setUiFormPayload,
  setUploadedDocuments,
  setAllPromptsData,
} from "../slices/flowFormSlice";
import apiClient from "../../config/apiClient";
import dotnetApiClient from "../../config/dotnetApiClient";
import {
  anonymousUser,
  checkDependantQuestionDefaultValue,
  generateGuid,
  handleLogout,
  logErrorFunction,
} from "../../helper/service";
import { getProgressData, getSummaryData } from "./documentThunk";
import type { RootState, AppDispatch } from "../store";
import Logger from "../../helper/loggerfunction";

const logger = new Logger();
const localData: any = localStorage.getItem("bootstrapData");
const bootstrapData: any = JSON.parse(localData);

export const getPublicUserForm: any = createAsyncThunk(
  "getPublicUserForm",
  async (_request: any, { dispatch }) => {
    try {
      const visitorId = _request?.visitorId;
      const id = _request?.id;
      dispatch(setLoading(true));
      const response = await apiClient().get(`public/public-user-form/${id}/${visitorId}`);
      dispatch(setLoading(false));

      if (response?.data) {
        dispatch(setAllFormData(response?.data?.data));
        // dispatch(notificationSuccess("Get form Data "));
      } else {
        dispatch(notificationFail(response?.data?.message || "Something went wrong"));
      }
    } catch (error: any) {
      if (error?.response?.status === 401 || error?.response?.status === 406) {
        handleLogout();
      }
      dispatch(setLoading(false));
      dispatch(notificationFail("Something went wrong"));
    }
  }
);

export const addUserForm: any = createAsyncThunk(
  "addUserForm",
  async (_request: any, { dispatch, getState }) => {
    const state: any = getState();
    const { getSignleFormData } = state?.formReducer;
    const uiJson = JSON.parse(getSignleFormData?.uiJson || "[]");
    const flowJson = JSON.parse(getSignleFormData?.flowJson || "[]");
    const usapath_etag = sessionStorage.getItem("Usapath-Etag");
    const sessionID = sessionStorage.getItem("Usapath-Session-Id");
    const headers: any = {};
    try {
      dispatch(setLoading(true));
      dispatch(notificationClear());

      const _req = JSON.parse(_request?.form_data || "{}");

      sessionStorage.removeItem("updatedFormValues");

      const tempLocal: any = JSON.parse(sessionStorage.getItem("unSavedFormValues") || "{}");

      const tempArr: any = { ...tempLocal, ..._req }; // Copy existing key-value pairs from req

      const uiJsonMap = new Map(uiJson.map((item: any) => [item.id, item]));

      // Use reduce instead of flatMap for better performance
      const mergedData = flowJson?.nodes?.reduce((acc: any[], flowJsonData: any) => {
        const matchingItem = uiJsonMap.get(flowJsonData.id);
        if (matchingItem) {
          acc.push({ ...matchingItem, ...flowJsonData });
        }
        return acc;
      }, []);

      // if (Object.keys(tempArr).length > 0) {
      mergedData
        ?.filter((data: any) => data.data.nodeType === "question")
        .map((data: any) => {
          if (!Object.keys(tempArr).includes(data?.id)) {
            // Add new key-value pair into tempArr
            tempArr[data.id] = "";
          }
        });

      Object.entries(tempArr)?.map((record: any) => {
        if (record[1] === "") {
          mergedData
            ?.filter(
              (val: any) =>
                String(val?.id) === String(record[0]) && val.data.nodeType === "question"
            )
            .map((rec: any) => {
              tempArr[rec.id] = checkDependantQuestionDefaultValue(rec, tempArr);
            });
        }
      });

      dispatch(setUIFormPayloadLoading(true));

      if (usapath_etag !== undefined) {
        headers["Usapath-Etag"] = usapath_etag;
      }

      if (anonymousUser() || sessionStorage.getItem("Usapath-Emulate-UserScope") === "Readonly") {
        dispatch(setLoading(false));
        dispatch(setUIFormPayloadLoading(false));
        return true;
      }

      const response = await dotnetApiClient().post(`/uiFormPayload`, tempArr, {
        headers,
      });

      const res_headers = response.headers;
      const etag = res_headers["usapath-etag"];

      dispatch(setLoading(false));
      dispatch(setUIFormPayloadLoading(false));

      if (!response?.data) {
        dispatch(
          notificationFail(
            response?.data?.message ||
              "We have detected an error. Please contact support for assistance."
          )
        );
      } else {
        const progressBarStyle =
          JSON.parse(getSignleFormData?.flowJson || "{}").settings?.progressBarStyle || "section";

        if (progressBarStyle !== "section") {
          dispatch(getSummaryData());
        } else {
          dispatch(getProgressData());
        }
        dispatch(setLoading(false));
        sessionStorage.setItem("Usapath-Etag", etag);
      }

      const concatString: any = JSON.stringify({
        message: "UiFormPayload POST API called",
        sessionID: sessionID,
        UserId: bootstrapData?.id,
        RequestId: generateGuid(),
      });
      const encodedString = btoa(concatString);

      logger.log({
        level: "info",
        detailsJson: encodedString,
        component: "UiFormPayload POST API called",
      });
      return response;
      // }
    } catch (error: any) {
      if (error?.response?.status === 401 || error?.response?.status === 406) {
        handleLogout();
      }

      const concatString: any = JSON.stringify({
        message: "UiFormPayload POST API called error",
        sessionID: sessionID,
        UserId: bootstrapData?.id,
        RequestId: generateGuid(),
      });
      const encodedString = btoa(concatString);

      logger.log({
        level: "error",
        detailsJson: encodedString,
        component: "UiFormPayload POST API called error",
      });
      dispatch(setLoading(false));
    }
  }
);

export const addPublicUserForm: any = createAsyncThunk(
  "addPublicUserForm",
  async (_request: any, { dispatch }) => {
    try {
      dispatch(setLoading(true));
      dispatch(notificationClear());
      const response = await apiClient().post(`/public/publicUserForm/add`, _request);
      dispatch(setLoading(false));
      // dispatch(notificationSuccess("Update form Data successfully!"));

      if (!response?.data) {
        dispatch(notificationFail(response?.data?.message || "Something went wrong"));
      } else {
        dispatch(setUserForm(response?.data));
      }
    } catch (error: any) {
      if (error?.response?.status === 401 || error?.response?.status === 406) {
        handleLogout();
      }
      dispatch(setLoading(false));
      dispatch(notificationFail("Something went wrong"));
    }
  }
);

export const getSingleForm = createAsyncThunk<
  void,
  { uiFlowJsonId: string },
  {
    dispatch: AppDispatch;
    state: RootState;
  }
>("getSingleForm", async ({ uiFlowJsonId }, { dispatch }) => {
  const userDataLocal = localStorage.getItem("userData")
    ? JSON.parse(localStorage.getItem("userData") || "{}")
    : null;
  const sessionID = sessionStorage.getItem("Usapath-Session-Id");

  if (!userDataLocal) {
    // dispatch(notificationFail("User data not available"));
    return;
  }
  try {
    dispatch(setflowDataLoading(true));
    const response = await dotnetApiClient().get(`UiFlowJson/${uiFlowJsonId}`);

    if (response?.data) {
      dispatch(getProgressData());
      dispatch(setSingleFormData(response.data));
    } else {
      dispatch(notificationFail(response?.data?.message || "Something went wrong"));
    }

    const concatString: any = JSON.stringify({
      message: "UiFlowJson GET API called",
      sessionID: sessionID,
      UserId: bootstrapData?.id,
      RequestId: generateGuid(),
    });
    const encodedString = btoa(concatString);

    logger.log({
      level: "info",
      detailsJson: encodedString,
      component: "UiFlowJson/<flowJSonId> POST API called",
    });
    dispatch(setflowDataLoading(false));
  } catch (error: any) {
    if (error?.response?.status === 401 || error?.response?.status === 406) {
      handleLogout();
    }
    const concatString: any = JSON.stringify({
      message: "UiFlowJson<flowJSonId> POST API called error",
      sessionID: sessionID,
      UserId: bootstrapData?.id,
      RequestId: generateGuid(),
    });
    const encodedString = btoa(concatString);

    logger.log({
      level: "error",
      detailsJson: encodedString,
      component: "UiFlowJson/<flowJSonId> POST API called error",
    });
    dispatch(setflowDataLoading(false));
    dispatch(notificationFail("Something went wrong"));
  } finally {
    dispatch(setLoading(false));
  }
});

export const getSetSectionId: any = createAsyncThunk(
  "getSetSectionId",
  async (_request, { dispatch }) => {
    try {
      dispatch(setSectionId(_request));
    } catch (error: any) {
      if (error?.response?.status === 401 || error?.response?.status === 406) {
        handleLogout();
      }
      dispatch(setLoading(false));
      dispatch(notificationFail("Something went wrong"));
    }
  }
);

export const replenish: any = createAsyncThunk("replenish", async (_, { dispatch }) => {
  try {
    if (anonymousUser()) {
      // Below line is for incognito user issue while loggin and signout
      sessionStorage.clear();
      return true;
    }
    dispatch(setLoading(true));
    dispatch(setUiFormPayload(null));
    const response = await dotnetApiClient().get(`/UiFormPayload`);
    const res_headers = response.headers;
    const etag = res_headers["usapath-etag"];

    sessionStorage.setItem("Usapath-Etag", etag);

    if (!response?.data) {
      dispatch(notificationFail(response?.data?.message || "Data not  found"));
    } else {
      // dispatch(getProgressData());
      if (etag !== null) {
        if (response?.data && !Object.keys(response?.data).length) {
          dispatch(addUserForm()).then((res: any) => {
            if (res?.payload?.data) {
              sessionStorage.setItem("unSavedFormValues", JSON.stringify(res?.payload?.data));
              dispatch(setUiFormPayload(res?.payload?.data || {}));
            }
          });
        } else {
          sessionStorage.setItem("unSavedFormValues", JSON.stringify(response?.data));
          dispatch(setUiFormPayload(response?.data || {}));
        }
        dispatch(setLoading(false));
        return true;
      }
    }
  } catch (error: any) {
    if (error?.response?.status === 401 || error?.response?.status === 406) {
      handleLogout();
    }
    dispatch(setLoading(false));
    dispatch(notificationFail("Data not  found"));
  }
});

export const fetchDocuments: any = createAsyncThunk(
  "fetchDocuments",
  async (userId: any, { dispatch }) => {
    try {
      dispatch(setLoading(true));
      const response = await dotnetApiClient().get(`/UserDocument/user/${userId}/list`);
      dispatch(setLoading(false));
      if (!response?.data) {
        dispatch(notificationFail(response?.data?.message || "Json Not found for this version"));
        dispatch(setLoading(false));
      } else {
        dispatch(setUploadedDocuments(response.data));
        dispatch(setLoading(false));
      }
    } catch (error: any) {
      if (error?.response?.status === 401 || error?.response?.status === 406) {
        handleLogout();
      }
      logErrorFunction("Error fetching documents:" + error);
      dispatch(setLoading(false));
    }
  }
);
export const fetchDocumentsOfClient: any = createAsyncThunk(
  "fetchDocumentsOfClient",
  async (_request: any, { dispatch }) => {
    try {
      dispatch(setLoading(true));
      const response = await dotnetApiClient().get(`/UserDocument/list`);
      dispatch(setLoading(false));
      if (!response?.data) {
        dispatch(notificationFail(response?.data?.message || "Json Not found for this version"));
        dispatch(setLoading(false));
      } else {
        dispatch(setUploadedDocuments(response.data));
        dispatch(setLoading(false));
      }
    } catch (error: any) {
      if (error?.response?.status === 401 || error?.response?.status === 406) {
        handleLogout();
      }
      logErrorFunction("Error fetching documents:" + error);
      dispatch(setLoading(false));
    }
  }
);

export const getAllPromptsData: any = createAsyncThunk(
  "getAllPromptsData",
  async (_request, { dispatch }) => {
    try {
      dispatch(setLoading(true));
      const response = await dotnetApiClient().get(`intelligence/prompts`);
      dispatch(setLoading(false));

      if (response?.data) {
        dispatch(setAllPromptsData(response?.data || []));
      } else {
        dispatch(notificationFail(response?.data?.message || "Something went wrong"));
      }
    } catch (error: any) {
      dispatch(setLoading(false));
      dispatch(notificationFail("Something went wrong"));
    }
  }
);

export const generateAllByPromptsId: any = createAsyncThunk(
  "generateByPromptsId",
  async (_request: any, { dispatch }) => {
    try {
      dispatch(setLoading(true));
      const response: any = await dotnetApiClient().post(
        `/intelligence/users/${_request.userId}/prompts/generateForPrompts`,
        _request.promptIds
      );

      dispatch(setLoading(false));

      if (response?.data) {
        dispatch(notificationSuccess("All client value based intelligence generated successfully"));
        dispatch(getProgressData());
        dispatch(setLoading(false));
        sessionStorage.setItem("Usapath-Etag", response?.data?.etag);
      } else {
        dispatch(notificationFail(response?.data?.message || "Something went wrong"));
      }
      return response;
    } catch (error: any) {
      dispatch(setLoading(false));
      dispatch(notificationFail("Something went wrong"));
    }
  }
);
